import * as Paginator from "react-bootstrap-table2-paginator";

import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import {
  faClipboard,
  faDownload,
  faHome,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import {
  getAllCalibrationIssueByDate,
  getFailedArkList,
} from "../../Service/AllServicesAPI";
import Pagination from "react-bootstrap-table2-paginator";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import moment from "moment";
import swal from "sweetalert";

export default () => {
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [userInput, setUserInput] = useState("");
  const [entries, setEntries] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  //Pagination
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [isLoaded, setisLoaded] = useState(false);
  const [offset, setOffset] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    getAllArkCalibration(); // Function call to get Production list
    // eslint-disable-next-line
  }, []);

  const handlePageChange = async (page) => {
    let selectedPage = page - 1;
    console.log("page", page);
    console.log("selectedPage", selectedPage);
    setEntries([]);
    if (fromDate === "" && toDate === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getFailedArkList(selectedPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Get Pagination Production Result", result.data);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            console.log("totalSize", totalSize);
            console.log("data", data);
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
          } else {
            swal("Sorry", "Data is not present", "warning");
          }
        })
        .catch((error) => console.error("Error", error));
      console.log("entries", entries);
    }

    // Date wise pagination
    else if (fromDate !== "" && toDate !== "") {
      await getAllCalibrationIssueByDate(
        selectedPage,
        moment(fromDate).format("yyyy-MM-DD"),
        moment(toDate).format("yyyy-MM-DD")
      )
        .then((result) => {
          console.log("Get Pagination Date wise Field Issue Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            console.log("totalSize", totalSize);
            console.log("data", data);
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
          } else {
            swal("Sorry", "Data is not present", "warning");
          }
        })
        .catch((error) => {
          console.log("Get Field Issue Error", error);
        });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

  const getAllArkCalibration = async () => {
    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      setisLoaded(true);
      await getFailedArkList(currentPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Get Calibration Result", result.data);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotalCount(result.data.totalElements);
            setisLoaded(false);
          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
            setisLoaded(false);
            swal("Sorry", "Data is not present", "warning");
          }
          // console.log("setNoOfElements", noOfElements);
        })
        .catch((error) => {
          console.log("Get Calibration Error", error);
        });
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  const getCalibrationByDate = async () => {
    try {
      if (fromDate !== "" && toDate !== "") {
        await getAllCalibrationIssueByDate(
          currentPage,
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        )
          .then((result) => {
            console.log("Get Date wise Field Issue Result", result);
            if (result?.data?.content?.length !== 0) {
              const data = result.data.content;
              setEntries(data);
              setPageCount(result.data.totalPages);
              setTotalCount(result.data.totalElements);
            } else {
              setEntries([]);
              setPageCount();
              setTotalCount();
              swal("Sorry", "Data is not present", "warning");
            }
            // console.log("setNoOfElements", noOfElements);
          })
          .catch((error) => {
            console.log("Get Field Issue Error", error);
          });
      } else {
        swal("Failed", "Please select date", "error");
      }
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));
  const columns = [
    { dataField: "id", text: "Id", width: 100 },
    {
      dataField: "arkNo",
      text: "ARK No",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser No",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "workOrderSerialNo",
      text: "Work Order No",
      editable: false,
      headerAlign: "left",
      width: 100,
    },
    {
      dataField: "customerName",
      text: "Customer Name",
      editable: false,
      headerAlign: "left",
      width: 100,
    },
    {
      dataField: "customerMobileNo",
      text: "Customer Mobile No",
      editable: false,
      headerAlign: "left",
      width: 100,
    },
    {
      dataField: "serviceEngineerName",
      text: "Service Engineer Name",
      editable: false,
      headerAlign: "left",
      width: 100,
    },
    {
      dataField: "oprationType",
      text: "Operation Type",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "subOprationType",
      text: "Sub Operation Type",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "volumeTotalizer",
      text: "Volume Totalizer",
      editable: false,
      headerAlign: "left",
    },
  ];

  const customTotal = (from, to, size) => (
    <div>
      Showing {from} to {to} of {size} entries
    </div>
  );

  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };
    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <Formik
      initialValues={{
        firstname: "",
        lastname: "",
        companyname: "",
        mobileno: "",
        selectdesignation: "",
        email: "",
        country: "",
        state: "",
        address: "",
        city: "",
        desc: "",
      }}
      onSubmit={async (values) => {
        console.log(JSON.stringify(values, null, 2));
      }}
    >
      {(formik) => {
        return (
          <>
            {isLoaded ? (
        <div className="reportload"></div>
      ) : (
            <ToolkitProvider
              keyField="id"
              search={true}
              columns={columns}
              data={entries}
              exportCSV
            >
              {({ baseProps, searchProps, csvProps }) => (
                <Paginator.PaginationProvider
                  pagination={Pagination({
                    custom: true,
                    alwaysShowAllBtns: true,
                    totalSize: totalCount,
                    paginationTotalRenderer: customTotal,
                    onPageChange: (page) => {
                      handlePageChange(page);
                    },
                  })}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <Card>
                      <div className="table-responsive py-2">
                        <Card.Header>
                          <Row>
                            <Col xs={12} md={6} className="py-1">
                              {/* <Paginator.SizePerPageDropdownStandalone
                                {...paginationProps}
                              /> */}
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              className="d-flex justify-content-md-end py-1"
                            >
                              {/* <Search.SearchBar {...searchProps} /> */}
                              {/* <ExportCSVButton
                                {...csvProps}
                                className="btn btn-secondary mx-2"
                              >
                                <span>CSV</span>{" "}
                              </ExportCSVButton> */}
                            </Col>
                          </Row>
                        </Card.Header>
                        <Table
                          {...baseProps}
                          {...paginationTableProps}
                          bodyClasses="border-0"
                          rowClasses="border-bottom"
                          classes="table-flush dataTable-table"
                          // selectRow={selectRow}
                          cellEdit={cellEditFactory({ mode: "click" })}
                          headerClasses="header-class"
                          hover
                          striped
                          wrapperClasses="table-responsive"
                          remote={{ pagination: true }}
                        />
                        <Card.Footer>
                          <Row>
                            <Col
                              xs={12}
                              md={6}
                              className="d-flex align-items-center py-1"
                            >
                              {/* <Paginator.PaginationTotalStandalone
                                {...paginationProps}
                              /> */}
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                            >
                              <Paginator.PaginationListStandalone
                                {...paginationProps}
                              />
                            </Col>
                          </Row>
                        </Card.Footer>
                      </div>
                    </Card>
                  )}
                </Paginator.PaginationProvider>
              )}
            </ToolkitProvider>
            )}
          </>
        );
      }}
    </Formik>
  );
};
